export default __webpack_public_path__ + "static/media/gameart.90ebcfee.svg";